import api from '../../../../../lib/api';
import type { EscolhaDaMassa, PedidoDaMassa, ResultadoDaMassa } from '../NegociacaoFornecedor/verbaEmMassa';
import type { VisaoGravada } from './visaoDaNegociacaoSalva';

export type BulkChangeStatusPayload = {
  negotiationSupplierDatapointStatus: 'APPROVED' | 'DECLINED';
  datapointsIds: string[];
  visionSaved: string;
};

export type BulkChangeStatusResponse = {
  status: number;
  data: any;
};

/**
 * POST /ipa-app/api/ipa/v1/negotiations/change-status/bulk
 * Bulk approve or reject negotiation datapoints
 */
export const POSTBulkChangeStatus = async (payload: BulkChangeStatusPayload): Promise<BulkChangeStatusResponse> => {
  const response = await api({
    url: '/negotiations/change-status/bulk',
    method: 'PUT',
    expectToken: true,
    data: payload,
  });

  return response;
};

export type SellinAllowanceBulkPayload = PedidoDaMassa & {
  visionSaved: VisaoGravada;
};

/** Responde **por item**: o valor vai um só e é convertido pela alíquota de cada linha. */
export const PUTApplySellinAllowanceBulk = async (payload: SellinAllowanceBulkPayload): Promise<ResultadoDaMassa> => {
  const response = await api({
    url: '/negotiations/datapoints/sellin-allowance/bulk',
    method: 'PUT',
    expectToken: true,
    data: payload,
  });

  return response.data as ResultadoDaMassa;
};

/** Aqui a seleção já é uma lista de identificadores; a tela de busca usa outro corpo. */
export const enviarVerbaEmMassaDaNegociacao =
  (datapointsIds: string[], visionSaved: VisaoGravada) =>
  (escolha: EscolhaDaMassa): Promise<ResultadoDaMassa> =>
    PUTApplySellinAllowanceBulk({ ...escolha, datapointsIds, visionSaved });
